// Scroll-triggered animations via IntersectionObserver
(function() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  function observe() {
    document.querySelectorAll('.animate-on-scroll, .stagger-children').forEach(el => {
      observer.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', observe);
  window.birdieAnimations = { observe };
})();
